var map = {
	"./Icon.png": "d152",
	"./Icon2.png": "681f",
	"./LazyLovers.png": "84d8",
	"./LogoSlothysBakery.png": "935f",
	"./MatchTheRunes.png": "7287",
	"./Mix2WordIcon.png": "ba21",
	"./PigYearLogo.png": "2b7f",
	"./PizzaMasterLogo.png": "8c04",
	"./SlothysLogo.png": "a2ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0469";